// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__DWG8C","inputDescription":"styles_inputDescription__3paNa"};